import { AUTHORIZATION_HEADER } from '../../../../../../../src/authorization';
import { send } from '../../../../../../../src/network';
import {
  OrderGroupingStatus,
  type OrderDetail,
  type OrderDetailWithSideloadedTags,
  type OrderReady,
  type OrderShuffling,
} from '../../../../../../../src/types/OrderDetail';
import { convertTagIdsToTags } from '../../../../../../../src/utils/convertTagIdsToTags';
export { StatusEnum as OrderStatus } from '../../../../../../../src/types/StatusEnum';
export { type Product } from '../../../../../../../src/types/Product';
export {
  OrderGroupingStatus,
  type OrderDetail,
  type OrderReady,
  type OrderShuffling,
};

type Params = {
  orderId: number;
};

export async function getCustomerOrder({ orderId }: Params) {
  const response = await send<OrderDetailWithSideloadedTags>({
    path: `/api/v2/customers/self/orders/${orderId}/?sideload=tags`,
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });

  const order = response.data.order?.[0];
  const tags = response.data.tags;

  const data: OrderDetail = {
    ...order,
    bundles: order.bundles.map((bundle) => {
      return {
        ...bundle,
        pairing:
          bundle.pairing === null
            ? null
            : {
                ...bundle.pairing,
                ingredients: bundle.pairing.ingredients.map((ingredient) => {
                  return {
                    ...ingredient,
                    tags: convertTagIdsToTags(ingredient.tags || [], tags),
                  };
                }),
                tags: convertTagIdsToTags(bundle.pairing.tags, tags),
              },
      };
    }),
    products: order.products.map((product) => {
      return {
        ...product,
        tags: convertTagIdsToTags(product.tags, tags),
      };
    }),
    promo_product: order.promo_product
      ? {
          ...order.promo_product,
          tags: convertTagIdsToTags(order.promo_product.tags, tags),
        }
      : null,
  };

  return {
    status: response.status,
    data,
  };
}
